import { ExportTerminuApi } from 'tezaury-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import Uuid from '../../model/Uuid';
import getFileName from '../../functions/getFileName';

const client = new ExportTerminuApi(apiConfiguration(tezauryPrefixPath));

interface DocumentResponse {
  fileName: string;
  blob: Blob;
}

// eslint-disable-next-line import/prefer-default-export
export const exportTerminDetail = async (
  uuid: Uuid,
  options?: { headers?: never },
): Promise<ClientResponse<DocumentResponse>> => {
  const {
    data,
    headers,
    status,
  } = await client.getTerminInPdf(uuid, {
    ...options,
    responseType: 'blob',
  });

  const blob = data && new Blob([data]);
  const fileName = getFileName(headers);
  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};

// eslint-disable-next-line import/prefer-default-export
export const exportTerminDetailAdmin = async (
  uuid: Uuid,
  options?: { headers?: never },
): Promise<ClientResponse<DocumentResponse>> => {
  const {
    data,
    headers,
    status,
  } = await client.getTerminInPdfAdmin(uuid, {
    ...options,
    responseType: 'blob',
  });

  const blob = data && new Blob([data]);
  const fileName = getFileName(headers);
  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};
